/*
*   Card Carousel Functionality
*   Custom translateX-based card carousel for Umbraco GridCards component
*   Supports responsive card counts, RTL, bullet navigation, and prev/next controls
*/

$(document).ready(function () {
    $('.card-carousel').each(function () {
        var cardCarousel = $(this);
        var orbitContainer = cardCarousel.find('.orbit-container');
        var cards = orbitContainer.find('.grid-card');
        var totalCards = cards.length;
        var visibleCards = 3;
        var activeIndex = 0;
        var isRtl = $('html').attr('dir') === 'rtl';
        // 13184 — video cards (gridCard.cshtml, .card--video). Everything guarded by this flag
        // is a no-op on every carousel without one, so those behave exactly as before.
        var hasVideo = cards.find('.card--video').length > 0;

        // Pause a card's player if it has been started. The iframe has no src until its play
        // button is pressed (see gridCard.cshtml), so an unplayed card is skipped. YouTube
        // players are opened with enablejsapi=1 so they take the command; Vimeo takes it as is.
        function pauseCardVideo(card) {
            $(card).find('.responsive-video--card iframe[src]').each(function () {
                var src = this.getAttribute('src') || '';
                var win = this.contentWindow;
                if (!win) { return; }
                if (src.indexOf('https://www.youtube.com/') === 0) {
                    win.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }), 'https://www.youtube.com');
                } else if (src.indexOf('https://player.vimeo.com/') === 0) {
                    win.postMessage(JSON.stringify({ method: 'pause' }), 'https://player.vimeo.com');
                }
            });
        }

        // Determine visible cards based on container width and CMS value
        function updateVisibleCards() {
            var parentWidth = cardCarousel.width();
            var cmsDesktopCards = parseInt(cardCarousel.attr('data-cards-to-show-carousel')) || 3;

            if (parentWidth < 550) {
                visibleCards = 1;
            } else if (parentWidth <= 1024) {
                visibleCards = cmsDesktopCards === 1 ? 1 : 2;
            } else if (parentWidth < 1300) {
                if (cmsDesktopCards === 1) {
                    visibleCards = 2;
                } else if (cmsDesktopCards >= 2 && cmsDesktopCards <= 3) {
                    visibleCards = cmsDesktopCards;
                } else {
                    visibleCards = 4;
                }
            } else {
                if (cmsDesktopCards === 1) {
                    visibleCards = 2;
                } else {
                    var maxPossibleCards = Math.floor(parentWidth / 300);
                    visibleCards = Math.min(cmsDesktopCards, maxPossibleCards);
                }
            }
            return parentWidth;
        }

        // Update slide widths, translation, and navigation state
        function updateSlides() {
            var parentWidth = updateVisibleCards();
            var cardWidth = parentWidth / visibleCards;

            cards.css('width', cardWidth + 'px');
            var containerWidth = cardWidth * totalCards;
            orbitContainer.css('width', containerWidth + 'px');

            var maxIndex = Math.max(0, totalCards - visibleCards);
            if (activeIndex > maxIndex) {
                activeIndex = maxIndex;
            }
            if (activeIndex < 0) {
                activeIndex = 0;
            }

            var offset;
            if (isRtl) {
                var visibleWidth = cardWidth * visibleCards;
                var remainingWidth = containerWidth - visibleWidth;
                offset = remainingWidth - (activeIndex * cardWidth);
            } else {
                offset = -(activeIndex * cardWidth);
            }
            orbitContainer.css('transform', 'translateX(' + offset + 'px)');

            // Force reflow for images
            orbitContainer.find('.grid-card img').each(function () {
                var img = $(this);
                if (img.complete) {
                    img.css('opacity', '0.99').css('opacity', '1');
                } else {
                    img.on('load', function () {
                        img.css('opacity', '0.99').css('opacity', '1');
                    });
                }
            });

            // Update bullet navigation active state
            cardCarousel.find('.orbit-bullets button').removeClass('is-active');
            cardCarousel.find('.orbit-bullets button').eq(activeIndex).addClass('is-active');

            // 13184 — a video that slides out of view stops, rather than playing on unseen.
            if (hasVideo) {
                cards.each(function (i) {
                    if (i < activeIndex || i >= activeIndex + visibleCards) {
                        pauseCardVideo(this);
                    }
                });
            }
        }

        if (hasVideo) {
            // 13184 — one video at a time: starting a card pauses any other card already
            // playing in this carousel. The shared handler in components.js (bound on the
            // button itself, so it runs first) has already written the src. The player then
            // joins the tab order and the accessibility tree (gridCard.cshtml keeps the empty
            // iframe out of both) and takes focus, because that handler removes the button
            // that held it.
            cardCarousel.on('click', '.video-thumbnail-overlay', function () {
                var card = $(this).closest('.grid-card')[0];
                cards.not(card).each(function () { pauseCardVideo(this); });
                var iframe = $(this).siblings('iframe')[0];
                if (iframe) {
                    iframe.removeAttribute('tabindex');
                    iframe.removeAttribute('aria-hidden');
                    iframe.focus({ preventScroll: true });
                }
            });

            // 13184 — every video card holds a play button, so Tab reaches cards that are
            // off to the side. Bring the focused card into view instead of letting the browser
            // scroll the clipped container underneath the translateX layout.
            cardCarousel.on('focusin', '.grid-card', function () {
                var i = cards.index(this);
                var maxIndex = Math.max(0, totalCards - visibleCards);
                var target = activeIndex;
                if (i < activeIndex) {
                    target = i;
                } else if (i >= activeIndex + visibleCards) {
                    target = Math.min(i - visibleCards + 1, maxIndex);
                }
                if (target !== activeIndex) {
                    activeIndex = target;
                    updateSlides();
                }
                cardCarousel.scrollLeft(0);
            });
        }

        // RTL note (ticket 11385): with `flex-direction: row-reverse` on .orbit-controls
        // the DOM "previous" button is visually on the RIGHT and the DOM "next" button
        // is visually on the LEFT. Arabic users press the RIGHT button to advance forward
        // (their reading flows right-to-left, so the next item is visually leftward).
        // To make "press right → advance" work, the DOM "previous" handler must INCREMENT
        // activeIndex in RTL (and vice versa). Without this swap, pressing the visually-
        // right button would cycle 1 → 3 → 2 → 1 instead of 1 → 2 → 3 → 1 — confirmed
        // by Matt against Dallah Saudi prod 2026-05-07.
        cardCarousel.find('.orbit-previous').on('click', function () {
            var maxIndex = Math.max(0, totalCards - visibleCards);
            if (isRtl) {
                activeIndex = activeIndex < maxIndex ? activeIndex + 1 : 0;
            } else {
                activeIndex = activeIndex > 0 ? activeIndex - 1 : maxIndex;
            }
            updateSlides();
        });

        cardCarousel.find('.orbit-next').on('click', function () {
            var maxIndex = Math.max(0, totalCards - visibleCards);
            if (isRtl) {
                activeIndex = activeIndex > 0 ? activeIndex - 1 : maxIndex;
            } else {
                activeIndex = activeIndex < maxIndex ? activeIndex + 1 : 0;
            }
            updateSlides();
        });

        // Bullet navigation
        cardCarousel.find('.orbit-bullets button').on('click', function () {
            var targetIndex = parseInt($(this).attr('data-slide'));
            var maxIndex = Math.max(0, totalCards - visibleCards);
            targetIndex = Math.min(targetIndex, maxIndex);
            activeIndex = targetIndex;
            updateSlides();
        });

        // Preload images
        orbitContainer.find('.grid-card img').each(function () {
            var img = new Image();
            img.src = $(this).attr('src');
        });

        // Recalculate on resize
        $(window).resize(function () {
            updateSlides();
        });

        // Initialize
        updateSlides();
    });
});
